import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { UserUiService } from '../../../shared';
@Component({
  selector: 'app-error-page',
  standalone: true,
  imports: [TranslateModule, NgIf],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss'
})
export class ErrorPageComponent {
  private translate = inject(TranslateService);
  private router = inject(Router);
  private userUiService = inject(UserUiService);

  path: string = '';
  type: any;
  title: any;
  desc: any;
  private sub?: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.type = this.route.snapshot.paramMap.get('type');
    this.sub = this.route.data.subscribe((param) => {
      if (param['type']) {
        this.type = param['type'];
      }
      if (param['title']) {
        this.title = param['title'];
      }
      if (param['desc']) {
        this.desc = param['desc'];
      }
    });

    switch (this.type) {
      case '404':
        if (!this.title || !this.desc) {
          this.translate.get(['NOT_FOUND_PAGE.PAGE_NOT_FOUND', 'NOT_FOUND_PAGE.OOPPS1']).subscribe((translations) => {
            if (!this.title) {
              this.title = translations['NOT_FOUND_PAGE.PAGE_NOT_FOUND'];
            }
            if (!this.desc) {
              this.desc = translations['NOT_FOUND_PAGE.OOPPS1'];
            }
          });
        }
        break;
      case '403':
        if (!this.title || !this.desc) {
          this.translate
            .get(['NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED', 'NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED_TO_OPEN_THIS_PAGE'])
            .subscribe((translations) => {
              if (!this.title) {
                this.title = translations['NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED'];
              }
              if (!this.desc) {
                this.desc = translations['NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED_TO_OPEN_THIS_PAGE'];
              }
            });
        }
        break;
      case '500':
        if (!this.title || !this.desc) {
          this.translate
            .get(['NOT_FOUND_PAGE.INTERNAL_SERVER_ERROR', 'NOT_FOUND_PAGE.OOPPS2'])
            .subscribe((translations) => {
              if (!this.title) {
                this.title = translations['NOT_FOUND_PAGE.INTERNAL_SERVER_ERROR'];
              }
              if (!this.desc) {
                this.desc = translations['NOT_FOUND_PAGE.OOPPS2'];
              }
            });
        }
        break;
      case '419':
        this.translate
          .get(['NOT_FOUND_PAGE.UNAUTHENTICATED', 'NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED_TO_OPEN_THIS_PAGE'])
          .subscribe((translations) => {
            this.title = translations['NOT_FOUND_PAGE.UNAUTHENTICATED'];
            this.desc = translations['NOT_FOUND_PAGE.YOU_ARE_NOT_AUTHORIZED_TO_OPEN_THIS_PAGE'];
          });
        break;
      case '503':
        this.translate.get('NOT_FOUND_PAGE.UNDER_MAINTENANCE').subscribe((res) => {
          this.title = res;
        });
        break;
      default:
        this.translate
          .get([
            'NOT_FOUND_PAGE.OOPPS',
            'NOT_FOUND_PAGE.SOMETHING_WENT_WRONG',
            'NOT_FOUND_PAGE.LOOKS_LIKE_SOMETHING_WENT_WRONG'
          ])
          .subscribe((translations) => {
            this.type = translations['NOT_FOUND_PAGE.OOPPS'];
            if (!this.title) {
              this.title = translations['NOT_FOUND_PAGE.SOMETHING_WENT_WRONG'];
            }
            if (!this.desc) {
              this.desc = translations['NOT_FOUND_PAGE.LOOKS_LIKE_SOMETHING_WENT_WRONG'];
            }
          });
    }
  }

  checkUserType(type: number) {
    switch (type) {
      case 1:
      case 9:
      case 10:
        return '/admin';
      default:
        return '/admin/dashboard';
    }
  }

  goToHome() {
    this.router.navigate([this.userUiService.getInitialPage()]);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
